import React from 'react';

const Attach = () => (
  <svg width="17px" height="18px" viewBox="0 0 17 18" version="1.1">
    <title>C89E5C31-1CDD-43B7-8636-5998A00FF561</title>
    <desc>Created with sketchtool.</desc>
    <g
      id="Final-design--(Web)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Upload-documents-final"
        transform="translate(-690.000000, -257.000000)"
        fill="var(--PRIMARY)"
        fillRule="nonzero"
      >
        <g id="Upload-file" transform="translate(672.000000, 245.000000)">
          <g id="attach" transform="translate(18.000000, 12.000000)">
            <path
              d="M14.7185508,1.31125781 C12.9701953,-0.437097656 10.1257031,-0.437097656 8.37734766,1.31125781 L1.70078906,7.98778125 C1.49473828,8.19383203 1.49473828,8.52764062 1.70078906,8.73369141 C1.90683984,8.93974219 2.24064844,8.93974219 2.44669922,8.73369141 L9.12322266,2.05716797 C10.4192578,0.762152344 12.6765703,0.762152344 13.9726055,2.05716797 C15.3093516,3.39391406 15.3093516,5.5693125 13.9726055,6.90605859 L4.64973047,16.3339102 C3.85231641,17.1313242 2.46301172,17.1313242 1.66563281,16.3339102 C0.842976562,15.5112539 0.842976562,14.1729609 1.66563281,13.3503047 L10.6155703,4.29486328 C10.9143281,3.99610547 11.435625,3.99610547 11.734418,4.29486328 C12.0429492,4.60339453 12.0429492,5.10567187 11.734418,5.41423828 L3.15794531,14.0961797 C2.98005469,14.2740703 2.98005469,14.6641641 3.15794531,14.8420898 C3.36399609,15.0481406 3.69780469,15.0481406 3.90385547,14.8420898 L12.480293,6.16011328 C13.2004688,5.4399375 13.2004688,4.26909375 12.480293,3.54895312 C11.7828281,2.85148828 10.5660703,2.85250781 9.86966016,3.54895312 L0.919722656,12.6043594 C-0.304628906,13.8287109 -0.304628906,15.8553984 0.919722656,17.0797852 C1.51780078,17.6778633 2.31261328,17.9999912 3.15791016,17.9999912 C4.00320703,17.9999912 4.79808984,17.6778633 5.39564063,17.0798203 L14.7185156,7.65193359 C16.4668711,5.90357812 16.4668711,3.05957812 14.7185508,1.31125781 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Attach;
